import React from "react";
import { useDispatch } from "react-redux";
import {
  catalogCleanSearchText,
  catalogSetSearchText,
  cleanSearchingCatalogsPaginated,
  startSearchingCatalogPaginated,
} from "../../app/actions/catalogActions";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackCatalog = ({ searchText, setSearchText, itemsPerPage, setIsDisabledSearchText, isDisabledSearchText, setIsDisabledFilter, isDisabledFilter}) => {
  debugLogPages(":: SearchBackCatalog");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      setIsDisabledFilter(true);
      setIsDisabledSearchText(false);

      trackEvent({ component: "SearchCatalogs", event: "SearchCatalogs-Clicked", search: event.target.value });

      dispatch(catalogSetSearchText(event.target.value));

      dispatch(startSearchingCatalogPaginated(event.target.value, 0, itemsPerPage));
    } else {

      //console.log("7777, else, searchText", searchText);
      
      setIsDisabledFilter(false);
      setIsDisabledSearchText(false);

      dispatch(cleanSearchingCatalogsPaginated());
      dispatch(catalogCleanSearchText());
      
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
            disabled={isDisabledSearchText}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalog;
